// import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from '../src/components/Redux/Store';
import { BrowserRouter } from 'react-router-dom';//, NavLink, Redirect Commented because not in use
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import "./style.scss";

// ── Global fetch interceptor ─────────────────────────────────────────────────
// Widget components (BarList, LineList, Column_Pie, etc.) call fetch() directly
// and never pass X-UC.  This one-time patch ensures every /api/ request carries
// the authenticated user context so ApiActivityLogMiddleware can log actor details.
// CallApi already sets X-UC explicitly; the guard below prevents double-setting.
(function patchFetchWithUserCtx() {
    const _originalFetch = window.fetch;
    window.fetch = function (url, options) {
        options = options || {};
        try {
            const urlStr = (typeof url === 'string') ? url
                : (url instanceof Request) ? url.url : '';
            const headers = options.headers || {};
            if (urlStr.startsWith('/api/') && !headers['X-UC']) {
                const rawId   = localStorage.getItem('ajs_user_id');       // btoa("code:message")
                const rawRole = localStorage.getItem('_Host_Pro_type');     // btoa("userRole")
                const rawName = localStorage.getItem('hacker_user_detail'); // btoa("shortName:fullName")
                if (rawId && rawRole && rawName) {
                    const idParts   = window.atob(rawId).split(':');
                    const role      = window.atob(rawRole);
                    const nameParts = window.atob(rawName).split(':');
                    const userCtx   = `${idParts[0]}|${idParts[1]}|${role}|${nameParts.slice(1).join(':')}`;
                    options = { ...options, headers: { ...headers, 'X-UC': userCtx } };
                }
            }
        } catch (e) { /* never break a fetch call because of logging */ }
        return _originalFetch.call(this, url, options);
    };
})();

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

// ReactDOM.render(
//  <BrowserRouter basename={baseUrl}>
//    <App />
//  </BrowserRouter>,
//  rootElement)
//registerServiceWorker();
ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    rootElement);

